// Centralized copy constants for resource grid action menus
// Ensures consistent terminology across all insurance resource grid views

export const RESOURCE_GRID_COPY = {
  // Action menu items (exact text as specified)
  actions: {
    editProviderCredentialStatus: (
      firstName: string,
      lastName: string,
      suffix?: string
    ) => {
      const fullName = `${firstName} ${lastName}${
        suffix ? `, ${suffix}` : ''
      }`.trim();
      return `Edit Provider Credential Status for ${fullName}`;
    },
    bulkEditInsuranceRows: 'Bulk edit insurance rows under this plan',
    viewPlans: 'View plans',
  },

  // Helper tooltips (on hover)
  tooltips: {
    editProviderCredentialStatus:
      'Edit plan details for this specific provider.',
    bulkEditInsuranceRows:
      'Edit multiple insurance rows under this plan at once.',
    viewPlans: 'View all plans for this provider.',
  },

  // Bulk editor copy
  bulkEditor: {
    title: 'Bulk Edit Insurance Rows',
    summary: 'Editing rows filtered by: {filters} ({count} results)',
    selectAll: 'Select all',
    changesToApply: 'Changes to apply',
    saveChanges: 'Save Changes',
    cancel: 'Cancel',
    progress: 'Processing {current} of {total}...',
    completed: '{successCount} updated, {failureCount} failed',
    noRowsSelected: 'Please select at least one row to edit.',
    noChangesSelected: 'Please select at least one field to update.',
    exportFailures: 'Export failures (CSV)',
    statusFilter: 'Filter by status',
  },

  // Error states
  errors: {
    noRowFound:
      'No row found for this plan. Add or map plan before editing.',
    addPlanRow: 'Add plan row',
    dismiss: 'Dismiss',
    permissionDenied: "You don't have permission for this action.",
  },

  // Accessibility labels
  a11y: {
    rowActions: (providerName: string) =>
      `Row actions for ${providerName}`,
    menuButton: 'Open row actions menu',
    bulkEditModal: 'Bulk edit insurance rows modal',
    singleEditModal: 'Edit provider credential status modal',
  },
} as const;

// Type for copy constants
export type ResourceGridCopy = typeof RESOURCE_GRID_COPY;
